import React, { useRef, useState } from 'react'
import { SelectValue } from 'antd/lib/select'
import dp from 'dot-prop-immutable'

import { AddressState, Id } from 'src/types'
import { Select } from 'src/components/Formik'
import { SelectProps } from 'src/components/Formik/Select'
import StatesService from 'src/services/api/states'

type Props = Omit<SelectProps, 'loading' | 'options'> & {
  country: Id
}

export default function SelectState({
  defaultActiveFirstOption = true,
  formikProps,
  name,
  style,
  onChange,
  country,
  ...props
}: Props) {
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<AddressState[]>([])
  const [searchValue, setSearchValue] = useState<string>()

  const refTimeout = useRef<NodeJS.Timeout>(null)

  function setFieldValue(value: string) {
    formikProps.setFieldValue(name, value)

    formikProps.setFieldValue(
      name.replace('_id', ''),
      list.find(item => +item.state_id === +value)
    )
  }

  return (
    <Select
      {...props}
      dataTestId="state-list"
      defaultActiveFirstOption={defaultActiveFirstOption}
      filterOption={false}
      formikProps={formikProps}
      loading={loading}
      name={name}
      style={style}
      onChange={(
        value: SelectValue,
        option: React.ReactElement<any> | React.ReactElement<any>[]
      ) => {
        setFieldValue(`${value}`)
        onChange && onChange(value, option)
      }}
      onSearch={value => {
        setSearchValue(value)

        if (value) {
          clearTimeout(refTimeout.current)

          refTimeout.current = setTimeout(async () => {
            setLoading(true)

            const response = await StatesService.getAll({
              country,
              queryName: value
            })

            setLoading(false)

            if (response.data) {
              setList(response.data)
            }
          }, 500)
        }
      }}
      options={
        !searchValue && dp.get(formikProps.values, name)
          ? (() => {
              const stateObj = dp.get(
                formikProps.values,
                name.replace('_id', '')
              )

              return [
                {
                  label: stateObj?.name,
                  title: stateObj?.name,
                  value: `${stateObj?.state_id}`
                }
              ]
            })()
          : list.map(state => ({
              label: state.name,
              title: state.name,
              value: `${state.state_id}`
            }))
      }
      showSearch
    />
  )
}
